export const xsmallBreakpoint = '350px'
export const mediumBreakpoint = '769px'
export const largeBreakpoint = '1024px'
export const xlargeBreakpoint = '1216px'
export const fullhd = '1472px'
